<template>
  <DynamicText
    tag="span"
    styleGroup="Offer Text"
    :get="offerTextStyle.get"
    :set="offerTextStyle.set"
    ><slot
  /></DynamicText>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DynamicText from "../DynamicText.vue";

import { Brand } from "@fresh8/types/src/index";

export default defineComponent({
  name: "BrandedOffer",
  components: {
    DynamicText
  },
  setup() {
    return {
      offerTextStyle: {
        get(brand: Brand) {
          return brand.adTemplate.offer?.body;
        },
        set(brand: Brand, value: string) {
          if (!brand.adTemplate.offer) {
            brand.adTemplate.offer = {
              header: "",
              body: "",
              button: "",
              terms: ""
            };
          }

          brand.adTemplate.offer.body = value;
        }
      }
    };
  }
});
</script>
